export default class SelectableObject<T>{
    constructor(item: T, isSelected: boolean = false) {
        this.Item = item;
        this.IsSelected = isSelected
    }

    public Item: T;
    public IsSelected: boolean;
}




// WEBPACK FOOTER //
// ./ClientApp/components/FmdControls/BulkActions/SelectableObject.ts